import React from "react";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import { connect } from "react-redux";
//import { openModal } from "../../actions/Modal";
//import { setHistory, redirect } from "../../actions/App";
//import { ThemeContext } from "../../configurations/Theme";
// import Dashboard from "../../containers/Dashboard";
import CoverImage from "../../components/coverImage";
import PlantInformation from "../../components/EmployeCard/plantinformation";
import SideMenu from "../../components/sideMenu";
import Welcome from "../../containers/welcome";
import EmployeContainer from "../../containers/Employe";
import Dashboard from "../../containers/Dashboard";
import Creditors from "../../containers/Creditors";
import { UserAction } from "../../store/actions";
import AccountSetting from "../../containers/AccountSetting";
import Catalog from "../../containers/Catalog";
import OrderDetail from "../../containers/OrderDetail";
import CatalogNew from "../../containers/CatalogNew";
class AuthRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsedRight: true,
      collapsedLeft: false,
      ScreenWidth: window.innerWidth,
    };

    this.handleWidthChange = this.handleWidthChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      //this.props.redirect(this.props.location.pathname);
    }
    window.addEventListener("resize", this.handleWidthChange);
  }

  componentDidMount() {
    //this.props.setHistory(this.props.history);
    //this.props.redirect(this.props.location.pathname);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWidthChange);
  }
  handleWidthChange = () => {
    this.setState({
      ScreenWidth: window.innerWidth,
    });
  };
  toggleCollapsed = (type) => {
    this.setState({
      [type]: !this.state[type],
    });
  };

  render() {
    console.log("reactRouter", this.props);
    if (this.props.location.pathname === "/reauth") {
      //
      this.props.createLink();
    }
    if (this.props.location.pathname === "/checkaccount") {
      this.props.checkAccount({ flag: this.props.location.search });
    }
    return (
      <>
        <SideMenu {...this.props}>
          <Switch>
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/employees" component={EmployeContainer} />
            <Route exact path="/welcome" component={Welcome} />
            <Route exact path="/catalog" component={Catalog} />
            <Route exact path="/creditors" component={Creditors} />
            <Route exact path="/catalog/new" component={CatalogNew} />
            <Route exact path="/accounts" component={AccountSetting} />
            <Route exact path="/order/:id" component={OrderDetail} />
            <Route path="*" render={() => <Redirect to="/dashboard" />} />
          </Switch>
        </SideMenu>
      </>
    );
  }
}

//Shell.contextType = ThemeContext;

export default connect(
  (state) => ({ storeState: state }),
  (dispatch) => ({
    createLink: () => dispatch(UserAction.createLinkReq()),
    checkAccount: (data) => dispatch(UserAction.checkAccountReq(data)),
  })
)(AuthRoutes);
